import React from 'react';
import { Route } from 'react-router-dom';
import { AppRoute, RouteChild } from '../../types/routeTypes';
import { PrivateRoute, PublicRoute } from './routeGuard';
import { appRoutes } from './routeConfig';

const wrapComponent = (
  Component: React.LazyExoticComponent<React.FC> | React.FC,
  isPublic?: boolean,
  allowedRoles?: string[],
  noFooter?: boolean,
  isCommon?: boolean
) => {
  if(isCommon) {
     return <Component />;
  }
  else if (isPublic) {
    return (
      <PublicRoute>
        <Component />
      </PublicRoute>
    );
  } else  {
    return (
      <PrivateRoute
        allowedRoles={allowedRoles}
        noFooter={noFooter}
      >
        <Component />
      </PrivateRoute>
    );
  } 

};

const renderChildRoute = (child: RouteChild, parentAllowedRoles?: string[], isPublic?: boolean, isCommon?: boolean): React.ReactElement => {
  const allowedRoles = child.allowedRoles || parentAllowedRoles;

  return (
    <Route
      key={child.key}
      path={child.path}
      element={wrapComponent(child.component, isPublic, allowedRoles, child.noFooter, isCommon)}
    />
  );
};


const renderRoute = (route: AppRoute, dbRoutes?: AppRoute[]): React.ReactElement[] => {
  const routes: React.ReactElement[] = [];

  if (route.component) {
    routes.push(
      <Route
        key={route.key}
        path={route.path}
        element={wrapComponent(
          route.component,
          route.isPublic,
          route.allowedRoles,
          route.noFooter,
          route.isCommon
        )}
      />
    );
  }

  if (route.children) {
    routes.push(
      ...route.children.map(child =>
        renderChildRoute(child, route.allowedRoles, route.isPublic,  route.isCommon)
      )
    );
  }

  return routes;
};


export const renderRoutes = (dbRoutes?: AppRoute[]): React.ReactElement[] => {
  if (!dbRoutes || dbRoutes.length === 0) {
    return appRoutes.flatMap((route) => renderRoute(route));
  }

  const mergedRoutes = appRoutes.map((route) => {
    const dbRoute = dbRoutes.find((r) => r.key === route.key);
    return dbRoute ? { ...route, isPublic: dbRoute.isPublic, allowedRoles: dbRoute.allowedRoles, isCommon: dbRoute.isCommon } : route;
  });

  return mergedRoutes.flatMap((route) => renderRoute(route, dbRoutes));
};